module.exports = __webpack_public_path__ + "img/bottom_logo.b127506e.png";